import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Container, Center, Spinner } from '@chakra-ui/react';
import { toaster } from '@/components/ui/toaster';
import ViewCollection from './view-collection';
import { baseApi } from '@/utils/api';
import { Collection } from '@/lib/types';

interface Item {
  collection: Collection;
  ContentWithStructure: {
    groups: {
      name: string;
      contents: string[];
      ContentValues: {
        reference_id: string;
        name: string;
        description: string;
        content_type_name: string;
      }[];
    }[];
  };
  User: {
    first_name: string;
    last_name: string;
    email: string;
  };
}

export default function PublicCollection() {
  const { referenceId } = useParams<{
    referenceId: string;
  }>();
  const [item, setItem] = useState<Item | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getCollection = async () => {
      setItem(null);
      setIsLoading(true);

      try {
        const response = await baseApi.get(`public/collections/reference/${referenceId}`);
        const item = await response.data;
        if (!item) {
          return;
        }
        setItem(item);
      } catch (err: any) {
        toaster.create({
          type: 'error',
          title: err.response?.data?.error || 'Failed to load collection',
        });
      } finally {
        setIsLoading(false);
      }
    };

    getCollection();
  }, [referenceId]);

  return (
    <Card.Root minH={'100vh'} mx={'auto'} width={{ md: '90%' }} maxW={'3xl'} className='print-card'>
      <Card.Body>
        <Container maxW={'container.md'}>
          {isLoading && (
            <Center py={10}>
              <Spinner size='xl' />
            </Center>
          )}

          {item && <ViewCollection item={item} isPublic={true} />}
        </Container>
      </Card.Body>
    </Card.Root>
  );
}
